import { SubscriptionPlan } from '../data_types/member-order';

export const getDefaultSubscription = (
    subscriptionPlans: SubscriptionPlan[] | undefined,
): SubscriptionPlan | undefined => {
    return subscriptionPlans?.find((sub: SubscriptionPlan) => sub.OrderApi__Number_Of_Installments__c === null);
};
